'use strict'

export function formatFiltersForServer (filters) {
  for (const prop in filters) {
    const filter = filters[prop]
    if (filter == null || typeof filter === 'boolean') {
      continue
    }

    const filterType = filter.type
    const subType = filter.subType

    delete filter.name
    delete filter.key
    delete filter.code
    delete filter.type
    delete filter.subType
    delete filter.disabled
    delete filter.hidden
    delete filter.active
    delete filter.updateOnChange
    delete filter.validateFn
    if (filter.activeAlways !== undefined) {
      delete filter.activeAlways
    }

    if (filterType === 'number' || filterType === 'integer' || filterType === 'string') {
      if (typeof filter.selectedMode === 'string') {
        // filter.selectedMode = filter.modes.find(o => o.key === filter.selectedMode)
        filter.selectedModeKey = filter.selectedMode
      } else if (filter.selectedMode) {
        filter.selectedModeKey = filter.selectedMode.key
      }
      delete filter.selectedMode
      if (filter.modes) {
        delete filter.modes
      }
      if (filterType === 'number' || filterType === 'integer') {
        if (filter.value === '') {
          filter.value = null
        }
        if (filter.selectedModeKey === 'interval' && filter.value2 === '') {
          filter.value2 = null
        }
      }
    } else if (filterType === 'select') {
      if (typeof filter.selectedValue === 'string') {
        filter.selectedValue = filter.values.find(o => o.key === filter.selectedValue)
      }
      if (filter.values) {
        delete filter.values
      }
    } else if (filterType === 'date') {
      if (filter.values) {
        filter.values = [(filter.values)]
      }
      if (filter.selectedMode === 'last' || filter.selectedMode === 'leftLess' || filter.selectedMode === 'leftMore' || //
        filter.selectedMode === 'overdueLess' || filter.selectedMode === 'overdueMore' || filter.selectedMode === 'more' || //
        filter.selectedMode === 'dateLast' || filter.selectedMode === 'dateNext' || filter.selectedMode === 'todayAndDateNext' //
      ) {
        if (typeof filter.value === 'string' && filter.value.length === 0) {
          filter.value = null
        }
      }

      filter.selectedMode = filter.modes.find(o => o.key === filter.selectedMode)
      delete filter.modes
      filter.selectedExtension = filter.extensions.find(o => o.key === filter.selectedExtension)
      delete filter.extensions
    } else if (filterType === 'list') {
      if (filter.selectedValues.length && filter.selectedValues.some(value => value instanceof Object)) {
        filter.selectedValues = filter.selectedValues.map(value => value.id || value.key || value).filter(value => !!value)
      }
      if (filter.values) {
        delete filter.values
      }
      if (filter.modes) {
        delete filter.modes
      }
    }
  }

  if (!filters.commonFilterUseConfigurable) {
    delete filters.useCommonFilter
    delete filters.commonFilterUseConfigurable
  }
  // delete filters.commonFilterUseConfigurable

  return filters
}

export function formatFiltersFromServer (filters, type, formId) {
  for (const prop in filters) {
    const filter = filters[prop]
    if (filter == null || typeof filter !== 'object' || filter.type == null) {
      continue
    }

    if (formId === 'mobile' && !filter.hidden && !filter.excluded) {
      filter.active = true
      filter.activeCustom = true
    }

    filter.validateFn = getValidateFn(filter)

    const filterType = filter.type
    if (filterType === 'select') {
      filter.selectedValue = filter.selectedValue ? filter.selectedValue.key : null
    } else if (filterType === 'number' || filterType === 'integer') {
      filter.selectedMode = filter.selectedMode.key
    } else if (filterType === 'date') {
      if (filter.values && filter.values.length !== 0) {
        filter.values = filter.values[0]
      }

      filter.convertedRange = {
        start: filter.from,
        end: filter.to
      }

      filter.selectedMode = filter.selectedMode.key
      filter.selectedExtension = filter.selectedExtension.key
    } else if (filterType === 'list') {
      // if (filter.subType !== 'selectedObjectIds' && filter.subType !== 'workTypes' && filter.subType !== 'table') {
      //   if (filter.multivalue) {
      //     filter.modes = [
      //       { key: 'containsAny', name: 'Содержит любое' },
      //       { key: 'containsAll', name: 'Содержит все' },
      //       { key: 'notContains', name: 'Не содержит любое' },
      //       { key: 'notContainsAll', name: 'Не содержит все' }
      //     ]
      //     filter.selectedMode = filter.inverted ? filter.modes[2] : filter.modes[0]
      //   } else {
      //     filter.modes = [
      //       { key: 'contains', name: 'Содержит' },
      //       { key: 'notContains', name: 'Не содержит' }
      //     ]
      //     filter.selectedMode = filter.inverted ? filter.modes[1] : filter.modes[0]
      //   }
      // }
      if (filter.subType === 'table') {
        filter.selectedValues = filter.values.map(value => {
          return {
            id: value.key,
            name: value.name
          }
        })
      } else if (formId !== 'mobile') {
        filter.selectedValues = filter.selectedValues.map(selectedValue => {
          const value = filter.values.find(value => value.key === selectedValue)
          if (value) {
            return {
              id: value.key,
              key: value.key,
              name: value.name
            }
          } else {
            return {}
          }
        })
      }
    }
  }
  return filters
}

export function formatFiltersToArray (filters) {
  return Object.entries(filters)
    .filter(([key, filter]) => filter != null && typeof filter === 'object' && filter.type != null)
    .map(([key, filter]) => {
      filter.key = key
      return filter
    })
    .sort((a, b) => (a.order > b.order) ? 1 : ((b.order > a.order) ? -1 : 0))
}

export function getValidateFn (filter) {
  const hasValueFn = getDefaultHasValueFn(filter.type)

  return function () {
    if (filter.required) {
      const val = getFilterValue(filter)
      return hasValueFn(val)
    }
    return true
  }
}

function getFilterValue (filter) {
  switch (filter.type) {
    case 'list':
      return filter.selectedValues
    case 'select':
      return filter.selectedValue
    case 'polygon':
      return filter.coords
    case 'date':
      switch (filter.selectedMode) {
        case 'interval':
        case 'intervalNoYear':
          return filter.from && filter.to
        case 'date':
        case 'dateUntil':
        case 'dateAfter':
        case 'dateNoYear':
          return filter.values
        case 'present':
        case 'absent':
        case 'any':
          // значение выбирается через selectedValues
          return true
        default:
          // все остальные selectedMode для date
          return filter.value
      }
    default:
      // integer, string
      return filter.value
  }
}

function getDefaultHasValueFn (type) {
  if (type === 'number' || type === 'integer' || type === 'selectedValue' || type === 'date') {
    return val => !!val
  } else if (type === 'polygon') {
    return val => !!val && val[0].length !== 0
  } else {
    return val => !!val && val.length !== 0
  }
}

export function validateFilters (filters) {
  const validFieldLabels = []

  filters.forEach(filter => {
    if (!filter.validateFn()) {
      validFieldLabels.push(filter.name)
    }
  })

  if (validFieldLabels.length === 0) {
    return Promise.resolve('Обязательные поля фильтра заполнены')
  } else {
    let message = ''
    if (validFieldLabels.length > 0) {
      message += 'Не заполнены обязательные поля фильтра: ' + validFieldLabels.map(val => '"' + val + '"').join(', ') + '.\n'
    }
    return Promise.reject(message)
  }
}
